import { GetProfileResult } from "results/users/GetProfileResult";
import { useApiService } from "services/ApiService";

export const UsersApiService = () => {
    const { get } = useApiService({ controller: "/users" });

    return {
        getProfile: () => get<GetProfileResult>("/profile"),
    };
};
